import Preview from "./Preview";

export default { Preview };
